import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./root";
import { SandboxForm, SandboxesView } from "../features/sandboxes";

export const sandboxesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sandboxes",
  component: SandboxesView,
});

// No detail route: a sandbox unfolds inside its own card.
export const newSandboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sandboxes/new",
  component: SandboxForm,
});
